// Helper functions for UI operations

/**
 * Hotel skeleton component for loading state
 * @returns {JSX.Element} - The skeleton component
 */
export const HotelSkeleton = () => (
  <div className="hotel-section skeleton">
    <div className="hotel-header">
      <div className="hotel-info">
        <div className="skeleton-image"></div>
        <div>
          <div className="skeleton-text large"></div>
          <div className="skeleton-text"></div>
          <div className="skeleton-text small"></div>
        </div>
      </div>
      <div className="hotel-actions">
        <div className="skeleton-button"></div>
        <div className="skeleton-button"></div>
        <div className="skeleton-button"></div>
      </div>
    </div>
    <div className="hotel-details">
      <div className="skeleton-text"></div>
      <div className="skeleton-text"></div>
      <div className="hotel-meta">
        <div className="skeleton-text small"></div>
        <div className="skeleton-text small"></div>
        <div className="skeleton-text small"></div>
        <div className="skeleton-text small"></div>
      </div>
    </div>
    <div className="rooms-section">
      <div className="table-header">
        <div className="skeleton-text"></div>
      </div>
      <div className="skeleton-table">
        <div className="skeleton-row">
          <div className="skeleton-text"></div>
          <div className="skeleton-text"></div>
          <div className="skeleton-text"></div>
          <div className="skeleton-text"></div>
          <div className="skeleton-actions">
            <div className="skeleton-button small"></div>
            <div className="skeleton-button small"></div>
          </div>
        </div>
        <div className="skeleton-row">
          <div className="skeleton-text"></div>
          <div className="skeleton-text"></div>
          <div className="skeleton-text"></div>
          <div className="skeleton-text"></div>
          <div className="skeleton-actions">
            <div className="skeleton-button small"></div>
            <div className="skeleton-button small"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

/**
 * Toggle hotel details visibility
 * @param {string} hotelId - The hotel ID
 * @param {Set} expandedHotels - The set of expanded hotels
 * @param {Function} setExpandedHotels - State setter for expanded hotels
 * @param {Function} fetchRoomsForHotel - Function to fetch rooms for a hotel
 * @returns {void}
 */
export const toggleHotelDetails = (hotelId, expandedHotels, setExpandedHotels, fetchRoomsForHotel) => {
  setExpandedHotels(prev => {
    const newSet = new Set(prev);
    if (newSet.has(hotelId)) {
      newSet.delete(hotelId);
    } else {
      newSet.add(hotelId);
      // Fetch rooms for this hotel when expanding
      fetchRoomsForHotel(hotelId);
    }
    return newSet;
  });
};

export default {
  HotelSkeleton,
  toggleHotelDetails
};